export default __webpack_public_path__ + "static/media/personality-share.e35c4008.svg";